import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: JSON.parse(localStorage.getItem('cartItems')) || [],
    syncQueue: [],
    loaded: false,
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        setCartItems(state, action) {
            state.items = action.payload;
            state.loaded = true;
            localStorage.setItem('cartItems', JSON.stringify(state.items));
        },
        addToCart: (state, action) => {
            const product = action.payload;
            const exists = state.items.find(item => item._id === product._id);

            if (exists) {
                exists.quantity = product.quantity;
            } else {
                state.items.push(product);
            }
            // if (!exists) {
            //     state.items.push(product);
            //     localStorage.setItem('cartItems', JSON.stringify(state.items));
            // }

            const inQueue = state.syncQueue.find(item => item._id === product._id);
            if (inQueue) {
                inQueue.quantity = product.quantity;
            } else {
                state.syncQueue.push(product);
            }

            localStorage.setItem('cartItems', JSON.stringify(state.items));
        },
        decreaseFromCart: (state, action) => {
            const productId = action.payload;
            const item = state.items.find(item => item._id === productId);

            if (item) {
                if (item.quantity > 1) {
                    item.quantity -= 1;

                    const inQueue = state.syncQueue.find(i => i._id === productId);
                    if (inQueue) {
                        inQueue.quantity = item.quantity;
                    } else {
                        state.syncQueue.push({ _id: productId, quantity: item.quantity });
                    }
                } else {
                    // remove item if quantity drops to 0
                    state.items = state.items.filter(item => item._id !== productId);
                    state.syncQueue.push({ _id: productId, quantity: 0 }); // 0 to indicate removal
                }
            }

            localStorage.setItem('cartItems', JSON.stringify(state.items));
        },
        removeFromCart: (state, action) => {
            state.items = state.items.filter(item => item._id !== action.payload);

            // Mark for removal in syncQueue
            state.syncQueue.push({ _id: action.payload, quantity: 0 });
            localStorage.setItem('cartItems', JSON.stringify(state.items));
        },
        clearCart: (state) => {
            state.items.forEach(item => {
                state.syncQueue.push({ _id: item._id, quantity: 0 }); // Mark all for deletion
            });
            state.items = [];
            localStorage.removeItem('cartItems');
        },
        clearSyncQueue: (state) => {
            state.syncQueue = [];
        },
    },
});

export const { addToCart, decreaseFromCart, removeFromCart, clearCart, clearSyncQueue, setCartItems } = cartSlice.actions;
export default cartSlice.reducer;
